<h2 mat-dialog-title>Refund Reason</h2>

<form [formGroup]="refundForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>

    <div class="reason-section">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select refund reason</mat-label>
        <mat-select [(value)]="selectedPresetReason" (selectionChange)="onPresetReasonChange()">
          <mat-option *ngFor="let reason of presetReasons" [value]="reason">
            {{ reason }}
          </mat-option>
          <mat-option value="other">Other</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="selectedPresetReason === 'other'" appearance="outline" class="full-width custom-textarea">
        <mat-label>Other reason (required)</mat-label>
        <textarea
          matInput
          formControlName="reason"
          rows="4"
          placeholder="Type your reason here"
          (input)="triggerRevalidation()">
        </textarea>
      </mat-form-field>
    </div>

    <div *ngIf="filteredOrderDetail?.length; else noProducts" class="product-list">
      <p><strong>Select products to refund:</strong></p>
      <div *ngFor="let product of filteredOrderDetail; let i = index" class="refund-product-row"
        [formGroup]="productsFormArray.at(i)">
        <mat-checkbox formControlName="selected" (change)="updateSelectedProductDetails()">
          {{ product.name }}
        </mat-checkbox>

        <div *ngIf="productsFormArray.at(i).get('selected')?.value" class="refund-controls">
          <mat-form-field appearance="fill" class="quantity-field">
            <mat-label>Qty</mat-label>
            <input
              matInput
              type="number"
              min="1"
              [max]="product.num - (refundedQuantities[product.id] || 0)"
              formControlName="refundQty"
              (keydown)="blockTyping($event)"
              (input)="updateSelectedProductDetails()" />
          </mat-form-field>
          <span class="refund-line-total">
            {{ getRefundAmount(product, i) | number:'1.2-2' }} kr
          </span>
        </div>
      </div>
    </div>

    <ng-template #noProducts>
      <p>All products have already been refunded.</p>
    </ng-template>

    <div *ngIf="selectedProductDetails?.length" class="refund-summary-box">
      <h4>Refunding:</h4>
      <ul>
        <li *ngFor="let item of selectedProductDetails">
          {{ item.name }} — {{ item.refundQty }} * {{ item.detailPrice }} kr =
          {{ item.refundQty * item.detailPrice | number:'1.2-2' }} kr
        </li>
      </ul>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="theme-button" type="button" (click)="onCancel()">Cancel</button>
    <button class="theme-button" type="submit" [disabled]="!isFormValid()">Submit</button>
  </mat-dialog-actions>
</form>
